import { productIdFormat } from "@redotech/redo-product-id";
import {
  binCountSessionIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";

const BinStatus = z.object({
  storageLocationId: storageLocationIdFormat.schema,
  binName: z.string(),
  countedAt: z.date().nullable(),
  deletedAt: z.date().nullable(),
  lotNumber: z.string().nullable(),
  expirationDate: z.date().nullable(),
});

export const getBinCountSession = {
  name: "getBinCountSession" as const,
  input: z.object({ binCountSessionId: binCountSessionIdFormat.schema }),
  output: z.object({
    binCountSessionId: binCountSessionIdFormat.schema,
    productId: productIdFormat.schema.nullable(),
    productTitle: z.string().nullable(),
    productSku: z.string().nullable(),
    productImageUrl: z.string().nullable(),
    marketplaceBin: z.string().nullable(),
    bins: z.array(BinStatus),
    completedAt: z.date().nullable(),
    deletedAt: z.date().nullable(),
    createdAt: z.date(),
  }),
};
